import React, { ReactElement } from 'react'
import { formatDateString } from '@/utils/formatting'
import Box from '@/components/boxes/Box'
import LoadImageOnDemand from '@/components/LoadImageOnDemand'
import { ClaimData } from '@/database/claim'

interface ClaimedProps {
    claimData: ClaimData
}

const ClaimedArtWork = ({ claimData }: ClaimedProps): ReactElement => {
    try {
        return (
            <div key={claimData.claim.id} className="artwork-box center width400">
                <div className="menu-wrapper-row">
                    <div>
                        <div className={'header-container'}>
                            <Box caption={'Claim'} text={'#' + claimData.claim.id} />
                            {claimData.targetArt.nft.tokenId && claimData.targetArt.nft.tokenId > -1 && (
                                <div>
                                    <Box caption={'NFT Claimed'} text={'#' + claimData.targetArt.nft.tokenId} />
                                </div>
                            )}
                            {!claimData.targetArt.nft.tokenId && (
                                <div>
                                    <Box caption={'ART'} text={'#' + claimData.targetArt.id} />
                                </div>
                            )}
                        </div>
                        <div className={'header-container'}>
                            <div>
                                <Box caption={'Amount'} text={claimData.claim.amount} />
                            </div>
                            {claimData.castingArt.nft.tokenId && claimData.castingArt.nft.tokenId > -1 && (
                                <div>
                                    <Box caption={'NFT Owner'} text={'#' + claimData.castingArt.nft.tokenId} />
                                </div>
                            )}
                        </div>
                        <div className={'padding-bottom-five'}>
                            <Box
                                caption={'Claim Time'}
                                text={formatDateString(claimData.claim.createdAt)}
                                styleText={'small'}
                            />
                        </div>
                    </div>
                    <div className="image-container width-thirty width-max-100">
                        <LoadImageOnDemand
                            id={'art' + claimData.targetArt.id}
                            alt={claimData.targetArt.prompt}
                            imageId={claimData.targetArt.image.id}
                            style="z-index-zero"
                            link={'/crazy#nft-' + claimData.targetArt.nft.tokenId + '/'}
                        />
                    </div>
                </div>
            </div>
        )
    } catch (error) {
        // Handle the error here or display a fallback image
        console.error('Error rendering image:', error)
        return <div />
    }
}

export default ClaimedArtWork
